import React from "react";
import {
    StandardModalDescription,
    StandardModalSelect
} from "src/components";
import { TextLabel } from "../style";
import {
    DIRECTORY_LEVEL,
    getChildDirectories
} from "../../directoryLevels";

export function DirectorySelection({
    categories,
    directories,
    selectedCategory,
    selectedSubcategory,
    selectedTopic,
    selectedSubtopic,
    onCategoryChange,
    onSubcategoryChange,
    onTopicChange,
    onSubtopicChange,
    error,
    directoriesAreLoading
}) {
    const subcategories = selectedCategory === "category" || directoriesAreLoading ? [] :
        getChildDirectories(directories, selectedCategory, "", DIRECTORY_LEVEL.SUBCATEGORY);
    const topics = selectedSubcategory === "subcategory" ? [] :
        getChildDirectories(directories, selectedCategory, selectedSubcategory, DIRECTORY_LEVEL.TOPIC);
    const subtopics = selectedTopic === "topic" ? [] :
        getChildDirectories(directories, selectedCategory, selectedTopic, DIRECTORY_LEVEL.SUBTOPIC);

    return (
        <>
            <div>
                <TextLabel>Select Category</TextLabel>
                <StandardModalSelect value={selectedCategory} onChange={onCategoryChange} width="100%">
                    <option value="category">Please select a category</option>
                    {categories?.map(category => (
                        <option key={category.uuid} value={category.uuid}>{category.name}</option>
                    ))}
                </StandardModalSelect>
            </div>

            <div>
                <TextLabel>Select Sub-Category</TextLabel>
                <StandardModalSelect
                    value={selectedSubcategory}
                    onChange={onSubcategoryChange}
                    name="subcategory"
                    width="100%"
                    disabled={selectedCategory === "category" || directoriesAreLoading}
                    aria-busy={directoriesAreLoading}
                >
                    <option value="subcategory">
                        {directoriesAreLoading ? "Loading sub-categories..." : "Please select a sub-category"}
                    </option>
                    {subcategories.map(subcategory => (
                        <option key={subcategory.uuid} value={subcategory.uuid}>
                            {subcategory.categoryName}
                        </option>
                    ))}
                </StandardModalSelect>
            </div>

            <div>
                <TextLabel>Select Topic</TextLabel>
                <StandardModalSelect
                    value={selectedTopic}
                    onChange={onTopicChange}
                    name="topic"
                    width="100%"
                    disabled={selectedSubcategory === "subcategory"}
                >
                    <option value="topic">No Topic</option>
                    {topics.map(topic => (
                        <option key={topic.uuid} value={topic.uuid}>
                            {topic.categoryName}
                        </option>
                    ))}
                </StandardModalSelect>
            </div>

            <div>
                <TextLabel>Select Sub-Topic</TextLabel>
                <StandardModalSelect
                    value={selectedSubtopic}
                    onChange={onSubtopicChange}
                    name="subtopic"
                    width="100%"
                    disabled={selectedTopic === "topic"}
                >
                    <option value="subtopic">No Subtopic</option>
                    {subtopics.map(subtopic => (
                        <option key={subtopic.uuid} value={subtopic.uuid}>
                            {subtopic.categoryName}
                        </option>
                    ))}
                </StandardModalSelect>
                {error && <StandardModalDescription color="#D64545">{error}</StandardModalDescription>}
            </div>
        </>
    );
}
